<template>
  <div class="ButtonGradientBorderNew">
    <span class="centerText">
      <span class="Text">{{ ButtonText }}</span>
    </span>
  </div>
</template>

<style scoped>
.ButtonGradientBorderNew {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;

  width: fit-content;
  padding: 12px 24px;

  border-radius: 4px;
  border: 0px solid;
  backdrop-filter: blur(1px);

  transition: 0.4s;
}
.ButtonGradientBorderNew:hover {
  opacity: 0.8;
}

.ButtonGradientBorderNew::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 4px;
  padding: 1px;
  background: linear-gradient(221.26deg, #c548ab -3.4%, #635bff 101.08%);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.centerText {
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: row;
}
.centerText > * {
  margin-top: auto;
  margin-bottom: auto;
}

.Text {
  position: relative;
  width: fit-content;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 155%;
  color: #ffffff;
}
</style>

<script>
export default {
  name: "ButtonGradientBorder",
  props: {
    ButtonText: String,
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>
